<div class="admin-dashboard" *ngIf="analytics">

  <!-- KPI Cards -->
  <div class="kpi-grid">
    <div class="kpi-card blue">
      <div class="kpi-icon"><span class="material-symbols-outlined">group</span></div>
      <div class="kpi-body">
        <div class="kpi-value">{{ analytics.users.total | number }}</div>
        <div class="kpi-label">Total Members</div>
        <div class="kpi-sub">+{{ analytics.users.today }} today</div>
      </div>
    </div>
    <div class="kpi-card green">
      <div class="kpi-icon"><span class="material-symbols-outlined">female</span></div>
      <div class="kpi-body">
        <div class="kpi-value">{{ analytics.users.female | number }}</div>
        <div class="kpi-label">Female Profiles</div>
        <div class="kpi-sub">{{ femalePercent }}% of total</div>
      </div>
    </div>
    <div class="kpi-card amber">
      <div class="kpi-icon"><span class="material-symbols-outlined">male</span></div>
      <div class="kpi-body">
        <div class="kpi-value">{{ analytics.users.male | number }}</div>
        <div class="kpi-label">Male Profiles</div>
        <div class="kpi-sub">{{ malePercent }}% of total</div>
      </div>
    </div>
    <div class="kpi-card purple">
      <div class="kpi-icon"><span class="material-symbols-outlined">calendar_month</span></div>
      <div class="kpi-body">
        <div class="kpi-value">{{ analytics.users.this_month | number }}</div>
        <div class="kpi-label">This Month</div>
        <div class="kpi-sub">New registrations</div>
      </div>
    </div>
  </div>

  <!-- Revenue & Financial Overview -->
  <div class="section-card" *ngIf="analytics.revenue" style="border-left: 4px solid #10b981;">
    <h2 class="section-title">
      <span class="material-symbols-outlined" style="color: #10b981;">payments</span> Platform Revenue & Subscriptions
    </h2>
    <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 16px; margin-top: 14px;">
      <div style="background: #ecfdf5; padding: 18px; border-radius: 12px; border: 1px solid #a7f3d0;">
        <div style="font-size: 12px; font-weight: 700; color: #047857; text-transform: uppercase; letter-spacing: 0.05em;">Total Platform Revenue</div>
        <div style="font-size: 26px; font-weight: 800; color: #065f46; margin: 6px 0;">₹{{ (analytics.revenue.total_revenue || 0) | number }}</div>
        <div style="font-size: 11.5px; color: #059669; font-weight: 500;">Combined member & broker plans</div>
      </div>
      <div style="background: #f0fdf4; padding: 18px; border-radius: 12px; border: 1px solid #bbf7d0;">
        <div style="font-size: 12px; font-weight: 700; color: #166534; text-transform: uppercase; letter-spacing: 0.05em;">Member Subscriptions</div>
        <div style="font-size: 24px; font-weight: 800; color: #14532d; margin: 6px 0;">₹{{ (analytics.revenue.user_revenue || 0) | number }}</div>
        <div style="font-size: 11.5px; color: #15803d; font-weight: 500;">{{ analytics.revenue.user_subs_count || 0 }} active subscriptions</div>
      </div>
      <div style="background: #fdf2f8; padding: 18px; border-radius: 12px; border: 1px solid #fbcfe8;">
        <div style="font-size: 12px; font-weight: 700; color: #be185d; text-transform: uppercase; letter-spacing: 0.05em;">Broker Subscriptions</div>
        <div style="font-size: 24px; font-weight: 800; color: #831843; margin: 6px 0;">₹{{ (analytics.revenue.broker_revenue || 0) | number }}</div>
        <div style="font-size: 11.5px; color: #9d174d; font-weight: 500;">{{ analytics.revenue.broker_subs_count || 0 }} active broker plans</div>
      </div>
    </div>
  </div>

  <!-- Plan Breakdown -->
  <div class="section-card">
    <h2 class="section-title">
      <span class="material-symbols-outlined">card_membership</span> Plan Distribution & Revenue
    </h2>
    <div class="plan-breakdown">
      <div class="plan-bar-item" *ngFor="let plan of planBreakdownList">
        <div class="plan-bar-label">
          <span class="plan-badge" [class]="'badge-' + plan.code.toLowerCase()">{{ plan.code }}</span>
          <span class="plan-count">{{ plan.count | number }} users <strong *ngIf="getPlanRevenue(plan.code) > 0" style="color: #059669; margin-left: 6px;">• ₹{{ getPlanRevenue(plan.code) | number }}</strong></span>
        </div>
        <div class="plan-bar-track">
          <div class="plan-bar-fill" [style.width]="plan.percent + '%'" [class]="'fill-' + plan.code.toLowerCase()"></div>
        </div>
        <span class="plan-pct">{{ plan.percent }}%</span>
      </div>
    </div>
  </div>

  <!-- Signup Trend -->
  <div class="section-card">
    <h2 class="section-title">
      <span class="material-symbols-outlined">trending_up</span> Monthly Signups (Last 6 Months)
    </h2>
    <div class="trend-chart">
      <div class="trend-bar-group" *ngFor="let m of analytics.signup_trend">
        <div class="trend-bar-wrap">
          <div class="trend-bar" [style.height]="getTrendHeight(m.count) + 'px'" [title]="m.count + ' signups'">
            <span class="trend-val">{{ m.count }}</span>
          </div>
        </div>
        <div class="trend-month">{{ getMonthLabel(m._id.month) }}</div>
      </div>
    </div>
  </div>

</div>

<div class="loading-state" *ngIf="!analytics">
  <span class="material-symbols-outlined spin">autorenew</span> Loading analytics...
</div>
